// The gallery's chosen agent working indicator: the mark ticks a quarter-turn
// per beat with a springy settle. The HTML wrapper rotates (not the SVG
// group) so the transform origin stays reliable; see petal_tick_loader.css.
import '@apps/web/features/phoebe_chat_v3/ui/primitives/petal_tick_loader.css';

import { type ReactNode } from 'react';

import { FlowerMark } from '@apps/web/features/phoebe_chat_v3/ui/primitives/flower_mark';
import { cn } from '@apps/web/lib/utils';

export type PetalTickLoaderProps = Readonly<{
    readonly className?: string;
    readonly label?: string;
}>;

export function PetalTickLoader({
    className,
    label = 'Phoebe is working',
}: PetalTickLoaderProps): ReactNode {
    return (
        <span
            role="status"
            aria-label={label}
            className={cn(
                'phoebe-petal-tick text-muted-foreground inline-flex size-4 shrink-0',
                className,
            )}
        >
            <FlowerMark className="size-full" />
        </span>
    );
}
